// src/services/ttn/deviceNames.js
// ─────────────────────────────────────────────────────────────────────────────
// Map device IDs → human-readable station names.
// Source of truth: TTN console (verified 2026-03-11)
//
// HOW TO ADD A NEW DEVICE:
//   1. Find the device's ID from the TTN console (the "deviceId" field).
//   2. Add a new line:  '<device_id>': '<Station / School Name>',
//   3. Save — no other files need to change.
//
// To update names via UI (no code change needed):
//   Use the "Station Names" tab in the SuperAdmin dashboard.
// ─────────────────────────────────────────────────────────────────────────────

const DEVICE_NAMES = {
  // ── Western Kenya deployment ─────────────────────────────────────────────────
  '101990961244800001': 'St. Augustine Butunyi Primary School',
  '101990961244800005': 'St. Francis Sikanga Secondary School',
  '101990961244800061': "St Mary's Girls Butula Primary School",
  '101990961244800083': 'Lugulu AC Secondary School',
  '101990961244800101': 'St. Joseph Bumutiru Secondary School',
  '101990961244800102': 'Bwaliro Girls Secondary School',
  '101990961244800113': 'Bukhalarire Boys Secondary School',
  '101990961244800131': "Bumala 'B' Secondary School",
  '101990961244800184': "Butula Girls' Secondary School",
  '101990961244800201': 'Nambale Boys High School',
  '101990961244800207': 'Fr. Simon Sibembe Secondary School',
  '101990961244800222': 'Khayo Secondary School',
  '101990961244800246': "St. Paul's Mabunge Secondary School",
  '101990961244800270': 'St. Charles Lwanga Emukhuyu Secondary School',
  '101990961244800281': 'Busiada Girls Secondary School',
  '101990961244800302': 'St. Paul Elwanikha Girls School',
  '101990961244800306': 'Bishop Nicholas Stam Sikoma Secondary School',
  '101990961244800317': 'St. Thomas Aquinas Madende Secondary School',
  '101990961244800336': "St Peters Mung'abo Secondary School",
  '101990961244800342': 'St. Romanos Tingolo Mixed Secondary School',
  '101990961244800348': 'Nambale Urban Secondary School',
  '101990961244800361': "St. Paul's Bukhuma Secondary School",
  '101990961244800375': 'St. Paul Igara Secondary School',
  '101990961244800389': 'Malanga Mixed Secondary School',
  '101990961244800393': 'St. Paul Namaindi Secondary School',
  '101990961244800395': "Tom's Home Musokoto",

  // ── Other regions ─────────────────────────────────────────────────────────────
  '101990961244800212': 'Lukenya - Daystar University',
  '202003536241300473': 'Tiigo School',

  // ── Add future devices below ─────────────────────────────────────────────────
  // '<device_id>': '<Station Name>',
};

export default DEVICE_NAMES;
